const GiftVoucherTypeEnum = Object.freeze({
    BALANCE: 'Balance',
    EXPERIENCE: 'Experience',
});

module.exports = GiftVoucherTypeEnum;
